import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;

  data?: any[];
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,

  data: [],
};

const getCvOfCampaignSlice = createSlice({
  name: "getCvOfCampaign",
  initialState,
  reducers: {
    getCvOfCampaignStart: (
      state,
      action: PayloadAction<{
        screenCode: string;
        programCode: string;
        reviewCvId: string;
      }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getCvOfCampaignSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
    },
    getCvOfCampaignFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetCvOfCampaign: (state) => {
      state.data = [];
    },
  },
});

export const {
  getCvOfCampaignStart,
  getCvOfCampaignSuccess,
  getCvOfCampaignFailed,
  resetCvOfCampaign,
} = getCvOfCampaignSlice.actions;
export default getCvOfCampaignSlice.reducer;
